export default function page_videos() {
	
  $('.video-wrapper a').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true,
    closeOnBgClick: false
  });
	
}